module.exports = __webpack_public_path__ + "static/Ethan.6bbc734f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Ethan.jpg
// module id = 1298
// module chunks = 137408898365125